import { Link } from "react-router-dom";
import { useData } from "data/data-provider";
import moment from "moment";

const Logo = () => {
  const { companyDetails } = useData();
  const time = moment();
  const timeInMilliseconds = time.valueOf();

  const companyLogo = companyDetails?.company_logo
    ? `${companyDetails?.company_logo}?date=${timeInMilliseconds}`
    : "";

  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-text-color focus:outline-none focus:ring-0`}
    >
      {companyLogo && (
        <img
          width={120}
          height={60}
          src={companyLogo}
          alt={companyLogo ? "Company Logo" : "Logo"}
        />
      )}
    </Link>
  );
};

export default Logo;
